import SHG from '@runway/conductor';
import Analytics from '@schiphol/analytics';
import componentList from './component-list';

// eslint-disable-next-line max-statements
(function startup() {
    const html = document.documentElement;

    html.classList.remove('loading-js', 'no-js');
    html.classList.add('javascript');

    document.addEventListener('DOMContentLoaded', boot);

    function boot() {
        window.SHG = SHG;
        window.SHG.register(componentList);

        const analytics = new Analytics();
        const gtmId = html.getAttribute('data-gtm-id');

        if (gtmId) {
            analytics.init(gtmId);
            Analytics.track({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
        }

        window.SHG.init();
        window.SHG.scan();
    }
}());
